<template>
    <div class="block-editor cache-read">
        <div class="wrapper">
            <!-- Cache Key -->
            <section>
                <div class="title">{{ $t("tables.automationblock.cacheKey") }}</div>
                <TiptapEditor
                    :placeholder="$t('tables.automationblock.readKeyPlaceholder')"
                    :show-attributes="true"
                    v-model="clone.key"
                    automation-mode
                />
                <div class="help-text">
                    <i class="material-icons">info</i>
                    <span>{{ $t("tables.automationblock.readKeyHelp") }}</span>
                </div>
            </section>

            <!-- Default Value -->
            <section>
                <div class="title">{{ $t("tables.automationblock.defaultValueIfMissingTitle") }}</div>
                <TiptapEditor
                    :placeholder="$t('tables.automationblock.defaultValueIfMissingPlaceholder')"
                    :show-attributes="true"
                    v-model="clone.defaultValue"
                    automation-mode
                />
                <div class="help-text">
                    <i class="material-icons">lightbulb</i>
                    <span>{{ $t("tables.automationblock.defaultValueIfMissingHelp") }}</span>
                </div>
            </section>

            <!-- Output Info -->
            <section>
                <div class="output-info">
                    <div class="info-title">
                        <i class="material-icons">output</i>
                        <span>{{ $t("tables.automationblock.outputInfo") }}</span>
                    </div>
                    <div class="output-attributes">
                        <div class="attribute-item">
                            <code>{{ $t('auto.cacheReadBlockBlockidValue') }}</code>
                            <span>{{ $t("tables.automationblock.attrValueOrDefault") }}</span>
                        </div>
                        <div class="attribute-item">
                            <code>{{ $t('auto.cacheReadBlockBlockidFound') }}</code>
                            <span>{{ $t("tables.automationblock.attrCacheFound") }}</span>
                        </div>
                        <div class="attribute-item">
                            <code>{{ $t('auto.cacheReadBlockBlockidSuccess') }}</code>
                            <span>{{ $t("tables.automationblock.successBooleanLabel") }}</span>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";

export default {
    name: "CacheRead",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value || {
                key: "",
                defaultValue: "",
            }),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.cache-read {
    .wrapper {
        padding: 30px;

        section {
            margin-bottom: 20px;

            .title {
                margin-bottom: 10px;
                font-weight: 600;
                font-size: 16px;
                line-height: 20px;
            }

            .help-text {
                display: flex;
                align-items: flex-start;
                gap: 8px;
                margin-top: 8px;
                padding: 10px;
                background: #f0f8ff;
                border-radius: 6px;
                font-size: 13px;
                color: #666;

                .material-icons {
                    font-size: 18px;
                    color: #1890ff;
                }
            }

            .output-info {
                background: #f8f9fa;
                border-radius: 8px;
                padding: 15px;
                border-left: 3px solid #28a745;

                .info-title {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-weight: 600;
                    margin-bottom: 12px;
                    color: #28a745;

                    .material-icons {
                        font-size: 20px;
                    }
                }

                .output-attributes {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;

                    .attribute-item {
                        display: flex;
                        flex-direction: column;
                        gap: 4px;

                        code {
                            background: #e9ecef;
                            padding: 4px 8px;
                            border-radius: 4px;
                            font-size: 13px;
                            color: #d63384;
                        }

                        span {
                            font-size: 12px;
                            color: #666;
                        }
                    }
                }
            }
        }
    }
}
</style>

